<template>
	<div v-if="config" class="launcher-info">
		<div class="mobile-bg"></div>
		<cdnImage :src="config.launcherLogo" class="preview-img" />
		<div class="contents">
			<div class="title">{{ $t('main.launcher.title') }}</div>
			<div class="subtitle">{{ $t('main.launcher.subtitle') }}</div>
			<button :class="{ offPlatform: !isWindows }" @click="downloadLauncher">
				<svgIcon icon-holder-class="download" icon-id="icon-btn-download" />
				<div class="button-contents">
					<div class="download-title">{{ $t(`main.launcher.download.${isWindows ? '' : 'disabled-'}title`) }}</div>
					<div class="download-subtitle">
						{{ $t(`main.launcher.download.${isWindows ? '' : 'disabled-'}subtitle`) }}
					</div>
				</div>
			</button>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import cdnImage from '@/components/cdn-image';
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import downloadGame from '../../../plugins/launcherDownload';

export default {
	name: 'LauncherInfo',
	components: {
		cdnImage,
		svgIcon,
	},
	data() {
		return {};
	},
	computed: {
		...mapState(['config', 'isWindows']),
		NXLogSessionId() {
			return this.$cookie.get('NxLogSession') ? this.$cookie.get('NxLogSession') : new Date().toISOString();
		},
		language() {
			return this.$i18n.locale;
		},
		region() {
			return environment.region;
		},
		memberShipNo() {
			return this.region === 'global' ? 1 : this.region === 'th' ? 3 : this.region === 'tw' ? 4 : this.region === 'sea' ? 5 : null;
		},
	},
	mounted() {},
	async created() {
		this.getConfig();
	},
	methods: {
		...mapActions(['getConfig']),
		downloadLauncher() {
			if (!this.isWindows) return;
			dataLayer.push({
				event: 'Home Launcher Download',
			});
			downloadGame(10000, this.NXLogSessionId, this.memberShipNo, this.language, this.$route.query.partnerKey);
		},
	},
};
</script>

<style lang="less" scoped>
.launcher-info {
	align-items: center;
	display: flex;
	flex-direction: column;
	height: 436px;
	margin-top: 90px;
	overflow: hidden;
	position: relative;
	width: 100%;
	z-index: 1;
	.mobile-bg {
		background: url('~@/images/launcher-info/bg.png') no-repeat center;
		bottom: 0;
		height: 344px;
		left: 0;
		position: absolute;
		width: 100%;
		z-index: -1;
	}
	.preview-img {
		height: 180px;
		// object-fit: contain;
		margin: 0 0 35px 35px;
		width: 308px;
	}
	.contents {
		align-items: center;
		display: flex;
		flex-direction: column;
		margin: 0 auto;
		.title {
			color: white;
			font-family: Roboto;
			font-size: 27.5px;
			font-weight: bold;
			letter-spacing: 0.55px;
			margin-bottom: 20px;
			text-transform: uppercase;
		}
		.subtitle {
			color: rgba(255, 255, 255, 0.3);
			font-family: Roboto;
			font-size: 14px;
			letter-spacing: 0.28px;
			margin-bottom: 30px;
			text-align: center;
		}
		button {
			background-color: #0077ff;
			border: none;
			border-radius: 5px;
			color: white;
			height: 71px;
			margin: 0;
			outline: 0;
			padding: 0 20px 0 18px;
			transition: background-color 0.2s, background-color 0.2s, border-color 0.2s, color 0.2s;
			width: auto;
			&:not(:active):not(.offPlatform):hover {
				background-color: #4ca1ff;
			}
			&:active:not(.offPlatform) {
				background-color: #0c5097;
				color: rgba(255, 255, 255, 0.5);
				.download {
					opacity: 0.5;
				}
			}
			&.offPlatform {
				background-color: #535353;
				color: rgba(255, 255, 255, 0.5);
				cursor: default;
				.download {
					opacity: 0.5;
				}
			}
			.button-contents {
				display: inline-block;
				.download-title {
					font-size: 16px;
					font-weight: bold;
					margin-bottom: 5px;
					text-align: left;
					text-transform: uppercase;
				}
				.download-subtitle {
					font-size: 14.5px;
					text-align: left;
				}
			}
			.download {
				display: inline-block;
				height: 26px;
				margin: 0 13px 5px 0;
				width: 21px;
			}
		}
	}
}

@media (min-width: 768px) {
	.launcher-info {
		align-items: flex-start;
		background: url('~@/images/launcher-info/bg.png') no-repeat top;
		flex-direction: row;
		height: 304px;
		justify-content: center;
		.mobile-bg {
			display: none;
		}
		.preview-img {
			height: 206px;
			margin: 58px 22px 0 0;
			width: 352px;
		}
		.contents {
			align-items: flex-start;
			margin: 80px 0 20px 0;
			.subtitle {
				text-align: left;
			}
		}
	}
}

@media (min-width: 1024px) {
	.launcher-info {
		height: 290px;
		.preview-img {
			// background: url('~@/images/launcher-info/preview_1024.png') no-repeat center;
			// background-size: contain;
			height: 228px;
			margin: 47px 9px 0 0;
			width: 389px;
		}
		.contents {
			.title {
				font-size: 24.5px;
				letter-spacing: 0.49px;
			}
			.subtitle {
				font-size: 12px;
				letter-spacing: 0.24px;
				margin-bottom: 25px;
			}
			button {
				height: 50px;
				padding: 0 13px;
				.button-contents {
					.download-title {
						font-size: 12.5px;
						margin: 2px 0 0 0;
					}
					.download-subtitle {
						font-size: 10.5px;
					}
				}
				.download {
					background-size: contain;
					height: 19px;
					margin: 0 9px 3px 0;
					width: 15px;
				}
			}
		}
	}
}

@media (min-width: 1440px) {
	.launcher-info {
		background-repeat: repeat;
		height: 415px;
		.preview-img {
			// background: url('~@/images/launcher-info/preview_1440.png') no-repeat center;
			// background-size: contain;
			height: 327px;
			margin: 67px 13px 0 0;
			width: 556px;
		}
		.contents {
			margin: 140px 0 20px 0;
			.title {
				font-size: 36.5px;
				letter-spacing: 0.73px;
				margin-bottom: 30px;
			}
			.subtitle {
				font-size: 16px;
				letter-spacing: 0.32px;
				margin-bottom: 35px;
			}
			button {
				height: 71px;
				padding: 0 20px 0 18px;
				.button-contents {
					.download-title {
						font-size: 16px;
						margin: 0 0 5px 0;
					}
					.download-subtitle {
						font-size: 14.5px;
					}
				}
				.download {
					background-size: contain;
					height: 26px;
					margin: 0 13px 5px 0;
					width: 21px;
				}
			}
		}
	}
}
</style>
